import { Component, ChangeDetectionStrategy, input, output, signal, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from '@progress/kendo-angular-dialog';

import { Finding, GapAcknowledgment } from '../../services/policy-gap-analysis.service';

export interface AcknowledgmentFormData {
  acknowledged_by: string;
  note: string;
  is_compensating_control: boolean;
  compensating_control_description: string | null;
}

@Component({
  selector: 'app-acknowledge-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, DialogModule],
  templateUrl: './acknowledge-dialog.component.html',
  styleUrl: './acknowledge-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AcknowledgeDialogComponent implements OnInit {
  finding = input.required<Finding>();
  existingAcknowledgment = input<GapAcknowledgment | undefined>();

  saved = output<AcknowledgmentFormData>();
  cancelled = output<void>();

  public note = signal<string>('');
  public isCompensatingControl = signal<boolean>(false);
  public compensatingDescription = signal<string>('');
  public isSaving = signal<boolean>(false);

  ngOnInit(): void {
    const existing = this.existingAcknowledgment();
    if (existing) {
      this.note.set(existing.note);
      this.isCompensatingControl.set(existing.is_compensating_control);
      this.compensatingDescription.set(existing.compensating_control_description ?? '');
    }
  }

  public get isEditMode(): boolean {
    return !!this.existingAcknowledgment();
  }

  public onSave(): void {
    if (!this.note().trim()) return;

    this.isSaving.set(true);

    // Simulate save delay
    setTimeout(() => {
      this.saved.emit({
        acknowledged_by: 'current.user@company.com',
        note: this.note().trim(),
        is_compensating_control: this.isCompensatingControl(),
        compensating_control_description: this.isCompensatingControl()
          ? this.compensatingDescription().trim() || null
          : null,
      });
      this.isSaving.set(false);
    }, 300);
  }

  public onCancel(): void {
    this.cancelled.emit();
  }
}
